import ImageCarousel from "../../Components/Common/Carousel";
import EstandeSemImagem from "../../assets/images/estande_sem_imagem.png";
import DimensoesTable from "../ComponenteCompartilhado/DimensoesTable";
import ValoresTable from "../ComponenteCompartilhado/ValoresTable";
import CommercialModal from "../../Components/Common/ModalContatoComercial";
import { useFeira } from "../../Contexts/FeiraContext";
import { useState } from 'react';

const SidebarEstandeRenovacaoNovo = ({
  selectedEstandeInfo,
  corPrincipal,
  isMobile,
  setOpenMobile,
  whatsappPrincipal,
  nomeFeira,
  mensagemPadrao,
  openModalWhatsapp,
  setOpenModalWhatsapp,
  setOpenModalRenovacao,
  setOpenModalRenovacaoReserva,
  acessoRenovacaoLiberado,
  corSecundaria,
  label,
  exibirAviso,
  configuracao,
  isVisualizacaoInterna
}) => {
  const { 
    setShowModalConfirmado, 
    setShowModalConfirmadoReserva,
    setAcessoRenovacaoLiberado,
    preencherDadosExpositor 
  } = useFeira();

  const contatoComercial = [];
  const [imgError, setImgError] = useState(false);  
  selectedEstandeInfo?.whatsapp.length > 0 ? (
  selectedEstandeInfo?.whatsapp.map((contato, index) => (
    contatoComercial.push(
      { nome: contato.nome, 
        whatsapp_principal: contato.whatsapp_principal !== '' ? contato.whatsapp_principal : whatsappPrincipal
      }
    )
  ))) : contatoComercial.push(
    { nome: "", 
      whatsapp_principal: whatsappPrincipal
    }
  );

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value);
  };

  const handleClickRenovar = () => {
    const expositor = selectedEstandeInfo?.expositor?.[0];

    if (!expositor) {
      exibirAviso("Ops!", "Dados do expositor não encontrados.");
      return;
    }

    // Quando NÃO exige senha, não deve exigir email
    if (configuracao?.renovacao_com_senha === false) {
      setAcessoRenovacaoLiberado(true);
      preencherDadosExpositor(expositor);
      setOpenModalRenovacao(true); // abre o fluxo, mas o modal de confirmação será exibido direto
      return;
    }

    // Fluxo antigo: só exige email se houver validação por senha
    if (!expositor.email_renovacao) {
      exibirAviso("E-mail não encontrado", "E-mail de renovação não cadastrado.");
      return;
    }
      
    setOpenModalRenovacao(true);
  };

  const handleClickReservar = () => {
    const expositor = selectedEstandeInfo?.expositor?.[0];

    if (!expositor) {
      exibirAviso("Ops!", "Dados do expositor não encontrados.");
      return;
    }

    // Quando NÃO exige senha, não deve exigir email
    if (configuracao?.renovacao_com_senha === false) {
      setAcessoRenovacaoLiberado(true);
      preencherDadosExpositor(expositor);
      setOpenModalRenovacaoReserva(true); // abre direto confirmação de reserva
      setOpenMobile(false);
     
      return;
    }

    // Fluxo antigo: só exige email se houver validação por senha
    if (!expositor.email_renovacao) {
      exibirAviso("E-mail não encontrado", "E-mail de renovação não cadastrado.");
      return;
    }

    if (!acessoRenovacaoLiberado) {
      setOpenModalRenovacaoReserva(true);
      return;
    }

    preencherDadosExpositor(expositor);
    setOpenModalRenovacaoReserva(true);
    setOpenMobile(false);
  };

  const renderExpositorInfo = () => {
    if (!selectedEstandeInfo?.expositor || selectedEstandeInfo.expositor.length === 0) return null;
    const expositor = selectedEstandeInfo.expositor[0];
    const socialLinks = [
      { icon: "bx bxl-facebook", url: expositor.facebook },
      { icon: "bx bxl-instagram", url: expositor.instagram },
      { icon: "bx bxl-linkedin", url: expositor.linkedin },
      { icon: "bx bx-world", url: expositor.site },
    ].filter(link => link.url);

    return (
      <div style={{ padding: "0.5rem", borderRadius: "12px", background: "rgba(255, 255, 255, 0.15)", backdropFilter: "blur(4px)", border: "1px solid rgba(255, 255, 255, 0.2)" }}>
        <div className="d-flex align-items-center">
          {/* {expositor.logoUrl && (
            <div className="flex-shrink-0" style={{ background: "white", padding: "4px", borderRadius: "50%" }}>
              <img src={expositor.logoUrl} alt={expositor.nome} className="avatar-sm rounded-circle" style={{ objectFit: "contain", width: "45px", height: "45px" }} />
            </div>
          )} */}
          {expositor.logoUrl && !imgError && (
            <div className="flex-shrink-0" style={{ background: "white", padding: "4px", borderRadius: "50%" }}>
              <img 
                src={expositor.logoUrl} 
                alt={expositor.nome} 
                className="avatar-sm rounded-circle" 
                style={{ objectFit: "contain", width: "45px", height: "45px" }}
                onError={() => setImgError(true)} 
              />
            </div>
          )}
          <div className="flex-grow-1 ms-3 text-start">
            <h5 className="mb-0 text-white" style={{ fontSize: "15px", lineHeight: "1.2" }}>{expositor.nome}</h5>
            <small style={{ color: "rgba(255,255,255,0.8)", fontSize: "11px" }}>Expositor Confirmado</small>
          </div>
        </div>
        {socialLinks.length > 0 && (
          <div className="d-flex justify-content-start gap-2 pt-2 mt-2" style={{ borderTop: "1px solid rgba(255,255,255,0.1)" }}>
            {socialLinks.map((link, idx) => (
              <a key={idx} href={link.url} target="_blank" rel="noopener noreferrer" style={{ width: "30px", height: "30px", borderRadius: "6px", background: "white", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <i className={link.icon} style={{ color: corPrincipal, fontSize: "16px" }}></i>
              </a>
            ))}
          </div>
        )}
      </div>
    );
  };

  return (
    <div style={{ "--primary-color": corPrincipal, "--second-color": corSecundaria }}>
      <div className="sidebar-header">
        {isMobile && (
          <button onClick={() => setOpenMobile(false)} style={{ position: "absolute", top: 10, right: 10, background: "transparent", border: "none", fontSize: 26, color: "white", zIndex: 20 }}>×</button>
        )}
        <h4 style={{ color: 'white'}} >{selectedEstandeInfo?.nome || ""} {label}</h4>
        {selectedEstandeInfo?.pavilhao?.[0] && <span style={{ color: 'white'}}>{selectedEstandeInfo.pavilhao[0].nome}</span>}
        {renderExpositorInfo()}
      </div>

      <div className="sidebar-body">
        <ImageCarousel images={selectedEstandeInfo?.imagens || []} defaultImage={EstandeSemImagem} corFundo={corPrincipal} />
        <DimensoesTable selectedEstandeInfo={selectedEstandeInfo} corPrincipal={corPrincipal} />
        
        {acessoRenovacaoLiberado && selectedEstandeInfo?.valor_total_geral && (
          <div className="mt-3">
            <h5 style={{ color: "#464373" }}>VALOR TOTAL: {formatCurrency(selectedEstandeInfo.valor_total_geral)}</h5>
            <ValoresTable selectedEstandeInfo={selectedEstandeInfo} />
          </div>
        )}

        <div className="d-flex flex-column gap-2 mt-3">
          <div className="d-flex gap-2">
            <button onClick={handleClickRenovar} type="button" className="btn btn-success flex-grow-1" style={{ backgroundColor: corPrincipal }}>Renovar</button>
            <button onClick={handleClickReservar} type="button" className="btn btn-outline-success flex-grow-1">Reservar</button>
          </div>
          { !isVisualizacaoInterna && (
            <button onClick={() => setOpenModalWhatsapp(true)} type="button" className="btn btn-success">Comercial</button>)}
        </div>

         {openModalWhatsapp && (
            <CommercialModal isOpen={openModalWhatsapp} onClose={() => setOpenModalWhatsapp(false)} contacts={contatoComercial} nomeFeira={nomeFeira} corPrincipal="#25D366" />
          )}
      </div>
    </div>
  );
};

export default SidebarEstandeRenovacaoNovo;